import {Text} from "@chakra-ui/react";
import React from "react";

export const LoadingMoreRaffles = () => (<Text>Loading more raffles...</Text>);